import { render, staticRenderFns } from "./Idp.vue?vue&type=template&id=11f8c44e&scoped=true"
import script from "@/views/Users/Student/Idps/Idp.ts?vue&type=script&lang=ts&external"
export * from "@/views/Users/Student/Idps/Idp.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Users/Student/Idps/idp.scss?vue&type=style&index=0&id=11f8c44e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f8c44e",
  null
  
)

export default component.exports